import { CSSProperties } from "react";
import { Button } from "antd";
import styled from "styled-components";
import theme from "styles/theme";

export const LobbyContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 100fr;
  grid-column-gap: 30px;
  grid-row-gap: 30px;
`;

export const AddButton = styled(Button)`
  border-radius: ${(props) => props.theme["@round-component-border-radius"]};
  color: ${(props) => props.theme["@primary-color-brand"]};
  font-family: ${(props) => props.theme["@font-family"]};
  border-color: ${(props) => props.theme["@primary-color-brand"]};
  border-width: 2px;
  font-size: 18px;
  font-weight: bold;
  width: 225px;
  height: 80px;
  padding: 0;
  margin: 0;
  margin-bottom: 2px;
  &.ant-btn-dashed {
    background-color: ${(props) => props.theme.colors.backgroundColorLight};
    &:hover {
      background-color: ${(props) => props.theme.colors.backgroundColorLightHover};
    }
  }
`;

export const ShippingTruckIcon: CSSProperties = {
  marginRight: "10px",
  alignItems: "center",
};

export const AddButtonCol: CSSProperties = {
  paddingTop: 0,
};
export const PaddingRow: CSSProperties = { paddingTop: 1 };

export const TruckExitIcon: CSSProperties = {
  marginRight: "10px",
  alignItems: "center",
  color: theme["@primary-color-brand"],
};

export const RegisterButton = styled(Button)`
  height: 40px;
  width: 140px;
`;

export const CancelButton = styled(Button)`
  height: 40px;
  width: 140px;
  border: 1px solid ${(props) => props.theme.colors.manatee};
`;

export const FakeBtnConfirm: CSSProperties = {
  display: "none",
};
